import { InactiveAccounts } from "~/types/equipment"
import http from './http';

const inactiveAccountsService = {
  /**
   * Batch process inactive accounts (approve/reject)
   * @param params - Request parameters
   * @returns Batch process result
   */
  batchProcess: async (params: InactiveAccounts.BatchProcessAccountsRequest) => {
    const res = await http.put<InactiveAccounts.BatchProcessAccountsResponse>(
      '/v1/accounts/inactive/approval',
      params,
    );
    return res.data;
  },

  /**
   * Get inactive accounts list
   * @param params - Request parameters
   * @returns A paginated inactive accounts list
   */
  list: async (params: InactiveAccounts.GetInactiveAccountsRequest) => {
    const url = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        url.append(key, value.toString());
      }
    });

    const endpoint = `/v1/accounts/inactive${url.toString() ? `?${url.toString()}` : ''}`;
    const res = await http.get<InactiveAccounts.GetInactiveAccountsResponse>(endpoint);
    return res.data;
  },
};

export default inactiveAccountsService;
